import {
  GridMultipleChoiceQuestionConfig,
  GridMultipleChoiceQuestionSettings,
} from '@hyper-inferno/grid-multiple-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  Element,
  QuestionAnswerObject,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

interface GridMultipleChoiceElementBundle extends Element {
  config: GridMultipleChoiceQuestionSettings;
}
interface GridCell {
  row: number;
  col: number;
  val: string;
}
export class GridMultipleChoiceHandler
  implements QuestionHandler<GridMultipleChoiceQuestionConfig> {
  async buildConfig(
    el: GridMultipleChoiceElementBundle,
    ctx: ITransformationContext,
  ): Promise<GridMultipleChoiceQuestionConfig> {
    // TODO remove the filters after answer filtering is enabled for grid
    let rows = await ctx.listBuilding.getOptionsByListId(
      el.config.row_list_id,
      ctx,
      el.config.row_list_randomize_options,
    );

    let columns = await ctx.listBuilding.getOptionsByListId(
      el.config.column_list_id,
      ctx,
      el.config.column_list_randomize_options,
    );

    return {
      ...el.config,
      rows,
      columns,
    };
  }
  getValue(
    el: SurveyElement,
    response: QuestionAnswerObject,
  ): { [key: number]: number[] } {
    const selections = response[el.name] as GridCell[] | undefined;

    if (!Array.isArray(selections)) {
      return {};
    }

    const result: { [key: number]: number[] } = {};

    for (const item of selections) {
      if (item.val !== 'selected') {
        continue;
      }

      const row = Number(item.row);
      const col = Number(item.col);

      if (!result[row]) {
        result[row] = [];
      }

      result[row].push(col);
    }

    return result;
  }
}
